import { Input as ValidatedInput } from '../../form/validatedInput';
import { jobSchema } from '../../../store/jobs/schema';

type PropTypes = {
  type: string,
  propName: string,
  label: string,
  job: Job,
  updateJob: (job: Job) => void,
  touchedOverride?: boolean
  value?: string,
  disabled?: boolean,
  min?: string
}

export const DateInput: React.FC<PropTypes> = ({ type, propName, label, job, updateJob, touchedOverride, value, min }) => {

  const onChange = (value: any) => updateJob({ ...job, [propName]: value });
  const schema = jobSchema.extract(propName);

  return (
    <ValidatedInput
      type={type}
      label={label}
      value={value || (job as any)[propName]}
      schema={schema}
      onChange={onChange}
      min={min}
      touchedOverride={touchedOverride}
    />
  )
};